import { create } from "zustand";
import { ITemplateVersion } from "./Types";

interface TemplateVersionSelectorState {
  version: ITemplateVersion;
  setVersion: (version: ITemplateVersion) => void;
  resetRefetch: boolean;
  setResetRefetch: (resetRefetch: boolean) => void;
}

const useTemplateVersionSelectorStore = create<TemplateVersionSelectorState>(
  (set, get) => ({
    version: {} as ITemplateVersion,
    setVersion: (version) => set({ version }),
    resetRefetch: false,
    setResetRefetch: (resetRefetch) => set({ resetRefetch }),
  })
);

export default useTemplateVersionSelectorStore;
